/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const updateOrganisationCandidateProfileSettingsDataSchema = z.object({
	candidateProfileEnabled: z.boolean(),
	candidateProfileCvCollectionEnabled: z.boolean(),
})

export type UpdateOrganisationCandidateProfileSettingsDataSchema = z.infer<
	typeof updateOrganisationCandidateProfileSettingsDataSchema
>
